import { useState } from "react";


export default function CustomTabs(props) {

    const {tabs,handleTabs,activeTab} = props


  return (
    <div
      style={{
        borderBottom: "1px solid #e5e7eb",
        // padding: "0 20px",
        background: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "22px",
        }}
      >
        {tabs.map((tab) => {
          const isActive = activeTab === tab.name;

          if(!tab?.isVisiable) return null

          return (
            <button
              key={tab?.name}
              onClick={(e) => handleTabs(e,tab.name)}
              style={{
                border: "none",
                background: "transparent",
                padding: "10px 0",
                cursor: "pointer",
                position: "relative",
                fontSize: "12px !important",
                fontWeight: isActive ? "600" : "500",
                color: isActive ? "var(--brand-primary)" : "#6b7280",
              }}

              className="fontSize12px interRegular"
            >
              {
                tab?.img&& tab?.img
              }
              {tab?.name}

              {tab.isRequired && (
                <span style={{ color: "red" }}>*</span>
              )}

              {isActive && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "-1px",
                    left: 0,
                    width: "100%",
                    height: "3px",
                    background: "#1d4ed8",
                    borderRadius: "10px",
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}